import React, { useEffect, useState } from "react";
import AdminLayout from "../../Layout";
import NetworkIndicator from "../../../Practice/Components/NetworkIndicator.jsx";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Card } from "flowbite-react";
import axios from "axios";
import Loader from "../../../../components/Loader.jsx";
import { useNavigate } from "react-router-dom";
import { auth } from "../../../../utils/firebase";

const superAdminEmails = [
  "training@thebettertomorrow.in",
  "bettertomorrowoffi@gmail.com",
  "beta-admin@bt.in",
];

const Feedback = () => {
  const [campusList, setCampusList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [Isload , setIsload] = useState(false);
  const [userEmail, setUserEmail] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserEmail(user.email);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (userEmail && !superAdminEmails.includes(userEmail)) {
      navigate("/admin", { replace: true });
    }
  }, [userEmail, navigate]);

  useEffect(() => {
    const fetchCampusNames = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/apiforms/api/getCampusNames`
        );
        if (response.data.success) {
          setCampusList(response.data.data); 
        }
      } catch (error) {
        console.error("Error fetching campus names:", error);
      } finally {
        setLoading(false);
      }
    };

    

    fetchCampusNames();
  }, []);



   useEffect(()=>{
    setTimeout(()=>{
      setIsload(false);
    },2000);
  },[]);


if (loading || Isload) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-screen">
          <Loader />    
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <NetworkIndicator />
      <div className="p-10">
        <div className="flex items-center justify-between mb-8 max-md:gap-2">
          <div className="flex items-center">
            <button
              onClick={() => window.history.back()}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <IoMdArrowRoundBack className="w-6 h-6" />
            </button>
            <div className="ml-2 text-2xl font-bold max-md:text-lg">
              All Campus
            </div>
          </div>
        </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {campusList.map((campus, index) => (
        <Card
          key={index}
          className="mb-3 cursor-pointer"
          onClick={() => navigate(`/admin/feedback/${campus}`)}
        >
          <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
            {campus}
          </h5>
        </Card>
      ))}
    </div>
      </div>
    </AdminLayout>
  );
};

export default Feedback;
